import { render, staticRenderFns } from "./EditTownForm.vue?vue&type=template&id=d89dbcb6&scoped=true"
import script from "./EditTownForm.vue?vue&type=script&lang=js"
export * from "./EditTownForm.vue?vue&type=script&lang=js"
import style0 from "./EditTownForm.vue?vue&type=style&index=0&id=d89dbcb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89dbcb6",
  null
  
)

export default component.exports